export default "__VITE_ASSET__33a69efc__"